import { AnyAction } from "redux";

interface EngagementLetterState {
    letterComplete: boolean;
    letterId: string | null;
    progress: any[];
    error: string | null;
  }
  
  const initialState: EngagementLetterState = {
    letterComplete: false,
    letterId: null,
    progress: [],
    error: null,
  };
  
  const engagementLetterReducer = (state = initialState, action: AnyAction): EngagementLetterState => {
    switch (action.type) {
      case "START_ENGAGEMENT_LETTER_GENERATION":
        return { ...state, letterComplete: false, error: null };
      case "UPDATE_ENGAGEMENT_LETTER_PROGRESS":
        return { ...state, progress: action.payload.progress };
      case "UPDATE_ENGAGEMENT_LETTER":
        return { ...state, letterId: action.payload.letterId };
      case "FINISH_ENGAGEMENT_LETTER_GENERATION":
        return { ...state, letterComplete: true, letterId: action.payload.letterId };
      case "ENGAGEMENT_LETTER_GENERATION_FAILED":
        return { ...state, error: action.payload.error, letterComplete: false };
      default:
        return state;
    }
  };
  
  export default engagementLetterReducer;